import { FC } from 'react';
import { MigrationError } from 'types/migration';

interface ErrorListProps {
  errors: MigrationError[];
}

const ErrorList: FC<ErrorListProps> = ({ errors }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div style={{ marginTop: 16 }}>
      <h4 style={{ margin: '0 0 8px', fontSize: 14, color: '#d32f2f' }}>
        {errors.length} Row{errors.length !== 1 ? 's' : ''} Failed
      </h4>
      <div style={{ maxHeight: 240, overflowY: 'auto', borderRadius: 8, border: '1px solid #e0e0e0' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              <th style={{ padding: '6px 12px', textAlign: 'left', borderBottom: '1px solid #e0e0e0', width: 80 }}>Row</th>
              <th style={{ padding: '6px 12px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Error</th>
              <th style={{ padding: '6px 12px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Raw Data</th>
            </tr>
          </thead>
          <tbody>
            {errors.map((err, idx) => (
              <tr key={idx} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '6px 12px', color: '#757575', fontFamily: 'monospace' }}>{err.rowNumber}</td>
                <td style={{ padding: '6px 12px', color: '#d32f2f' }}>{err.message}</td>
                <td style={{ padding: '6px 12px', color: '#9e9e9e', fontFamily: 'monospace', fontSize: 12, maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{err.rawData}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ErrorList;
